export function singularize(value) {
  return value.endsWith('s') ? value.slice(0, -1) : value
}



// WEBPACK FOOTER //
// ./src/core/utils/string.js